import type { QueryClient } from "@tanstack/react-query";
import { SAVED_LISTINGS_QUERY_KEY } from "@/features/saved-listings";
import { VIEWER_COMPATIBILITY_QUERY_KEY } from "@/features/matching";
import { AUTH_QUERY_KEY } from "@/lib/core/auth";
import { FIND_FEED_QUERY_PREFIX } from "@/features/discovery";

export function invalidateViewerScopedQueries(queryClient: QueryClient) {
    void queryClient.invalidateQueries({ queryKey: AUTH_QUERY_KEY });
    void queryClient.invalidateQueries({ queryKey: SAVED_LISTINGS_QUERY_KEY });
    queryClient.setQueriesData(
        { queryKey: VIEWER_COMPATIBILITY_QUERY_KEY },
        {},
    );
    void queryClient.invalidateQueries({
        queryKey: VIEWER_COMPATIBILITY_QUERY_KEY,
    });
    void queryClient.invalidateQueries({ queryKey: FIND_FEED_QUERY_PREFIX });
    void queryClient.removeQueries({ queryKey: ["chat"] });
}
